module.exports = __webpack_public_path__ + "img/xmasParty2.503db8f7.jpg";